import { memo } from "react";
import { conditions } from "helpers";
import { ConditionName } from "interfaces";
import { useAppSelector } from "redux-share";
import { shallowEqual } from "react-redux";
import dynamic from "next/dynamic";
import MarkersList from "../../../player-components/markersList/markersList";
import Settings from "../../../player-components/settings/settings";
import Speed from "../../../player-components/speed/speed";
import Subtitles from "../../../player-components/subtitles/subtitles";

const FullScreen = dynamic(() => import("../../../player-components/fullScreen/fullScreen"));
const PlayList = dynamic(() => import("../../../player-components/playList/playList"));
const AutoPlayToggle = dynamic(() => import("../../../player-components/toggle/autoPlayToggle"));
const PictureInPicture = dynamic(() => import("../../../player-components/pictureInPicture/pictureInPicture"));
const Unlock = dynamic(() => import("../../../player-components/lockUnlock/unlock"));
const MultiLive = dynamic(() => import("../../../player-components/multiLive/multiLive"));
const ElapsedTime = dynamic(() => import("../../../player-components/elapsedTime/elapsedTime"));
const LikeDisLike = dynamic(() => import("../../../player-components/likeDisLike/likeDisLike"));
const SoundVolume = dynamic(() => import("../../../player-components/soundVolume/soundVolume"));
const PlayNextVideo = dynamic(() => import("../../../player-components/playNext/playNextVideo"));
const PlayPauseControllbar = dynamic(() => import("../../../player-components/playPauseControllbar/playPauseControllbar"));

const Controlbar = () => {
    useAppSelector(({ controller: { isFullScreen, showMiniPlayer } }) => ({ isFullScreen, showMiniPlayer }), shallowEqual);
    useAppSelector(
        ({ videoData: { videoElementSizeInfo, params, isComplexPortrait } }) => ({ videoElementSizeInfo, params, isComplexPortrait }),
        shallowEqual
    );

    return (
        <div id="player-controllbar" className={`pl-flex pl-justify-between pl-items-center pl-mx-3 pl-mb-3`}>
            <div
                className={`pl-flex pl-items-center ${
                    conditions(ConditionName.isFullMobilePortrait) || !conditions(ConditionName.isMiniPlayer) ? "pl-gap-5" : "pl-gap-2"
                }`}
            >
                {!conditions(ConditionName.showMiniPlayer) && <FullScreen />}
                {conditions(ConditionName.showSettingIcon) && <Settings />}
                {conditions(ConditionName.showSpeedIcon) && !conditions(ConditionName.isComplexPortrait) && <Speed />}
                {conditions(ConditionName.showPlayListIcon) && conditions(ConditionName.showPlaylist) && <PlayList />}
                {conditions(ConditionName.showPictureInPicture) && <PictureInPicture />}
                {!conditions(ConditionName.isGeneral) && !conditions(ConditionName.isTouchScreenPortrait) && <Unlock inControllbar={true} />}
                {conditions(ConditionName.showMultiLive) && <MultiLive />}
                {conditions(ConditionName.hasSubtitle) && <Subtitles />}
                {conditions(ConditionName.showAutoPlayToggleIcon) && <AutoPlayToggle />}
            </div>
            <div className={`pl-flex pl-items-center ${conditions(ConditionName.isMiniPlayer) ? "pl-gap-2" : "pl-gap-5"}`}>
                {conditions(ConditionName.showElapsedTime) &&
                    (!conditions(ConditionName.isMiniPlayer) || conditions(ConditionName.isFullMobilePortrait)) &&
                    !conditions(ConditionName.isComplexPortrait) && <ElapsedTime />}
                {conditions(ConditionName.showLikeDislike) && <LikeDisLike />}
                {conditions(ConditionName.showSpeedIcon) && conditions(ConditionName.isComplexPortrait) && <Speed />}
                {!conditions(ConditionName.isIOS) && <SoundVolume />}
                {conditions(ConditionName.hasMarkers) && !conditions(ConditionName.isComplexPortrait) && <MarkersList />}
                {conditions(ConditionName.showPlayNextIcon) && <PlayNextVideo />}
                {conditions(ConditionName.showReplayIcon) && <PlayPauseControllbar />}
            </div>
        </div>
    );
};

export default memo(Controlbar);
